import React from "react";
import Header from "@shared/components/Header";
import { ErrorProps } from "@pages/Error/utils/interfaces";

const ErrorGeneric: React.FC<ErrorProps> = ({
  errorTitle,
  errorDescription,
  errorImage,
  handleReload,
}) => {
  return (
    <>
      <Header />
      <div className="flex min-h-[75vh] flex-1 flex-col justify-center px-6 pt-8 lg:px-8 items-center">
        <img src={errorImage} className="my-5" alt="Error illustration" />
        <h2 className="text-3xl font-semibold my-3">{errorTitle}</h2>
        <p className="text-gray-400 mb-8 text-lg">{errorDescription}</p>
        {handleReload && (
          <button
            onClick={handleReload}
            className="bg-[#0357C9] text-white px-4 py-2 rounded-md mt-4"
          >
            Reload
          </button>
        )}
      </div>
    </>
  );
};

export default ErrorGeneric;
